import {Component, OnInit} from '@angular/core';
import {PerformanceSectionComponent} from "../component/performance-section/performance-section.component";
import {TemplateComponent} from "../template/template.component";

@Component({
  selector: 'app-updating-page',
  standalone: true,
  imports: [
    PerformanceSectionComponent
  ],
  templateUrl: './updating-page.component.html',
  styleUrl: './updating-page.component.css'
})
export class UpdatingPageComponent extends TemplateComponent implements OnInit{
  ngOnInit(): void {
    document.body.scrollTop = 0;
  }

}
